import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { ChangeLogPipesModule } from 'ag-common-svc/lib/components/changes-history-grid/pipes/change-log-pipes.module';
import { ChangeLogSignedPolicyComponent } from './change-log-signed-policy.component';

@NgModule({
  declarations: [ChangeLogSignedPolicyComponent],
  imports: [CommonModule, SharedModule, ChangeLogPipesModule],
  exports: [ChangeLogSignedPolicyComponent],
})
export class ChangeLogSignedPolicyModule {}
